// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1qIC6","content":"LayoutSettings_content__YSnZR"};